module.exports = __webpack_public_path__ + "img/114-09-floor.79ee4f67.jpg";